const e=async(e,t,n,r)=>{if(n){let{data:i}=await e.get(`/users/${t}/apps/${n}/orgs`,{params:r});return i}let{data:i}=await e.get(`/users/${t}/orgs`,{params:r});return i};export{e as getUserOrgs};
//# sourceMappingURL=get-user-orgs.mjs.map